export default "__VITE_ASSET__pOuA6Cgw0Hs2VRp4syQvcg__ 480w, __VITE_ASSET__SPRjEc5TCHUfgNsYUjJJwQ__ 745w";